import { render, staticRenderFns } from "./SwitchlangHeader.vue?vue&type=template&id=0ada3b38&scoped=true"
import script from "./SwitchlangHeader.vue?vue&type=script&lang=ts"
export * from "./SwitchlangHeader.vue?vue&type=script&lang=ts"
import style0 from "./SwitchlangHeader.vue?vue&type=style&index=0&id=0ada3b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada3b38",
  null
  
)

export default component.exports